import { usePaginatedRequest } from '@Hooks/usePaginatedRequest';
import { API } from '@Services';
import { ProjectUpdate } from '@Types';
import { useCallback } from 'react';

export const useGetGroupProjectUpdates = () => {
  const [fetch, response] = usePaginatedRequest<ProjectUpdate>({ perPage: 10 });

  const getGroupProjectUpdates = useCallback(
    (organizationId: number) => {
      fetch(API.paths.all_project_updates, {
        group_id: organizationId,
        is_hidden: false,
      });
    },
    [fetch],
  );

  return [getGroupProjectUpdates, response] as const;
};
